/** Pragmatic email check for form validation (not full RFC). */
export function isValidEmail(value) {
  if (value == null || typeof value !== "string") return false;
  const s = value.trim();
  if (!s) return false;
  return /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/i.test(s);
}
